import React from "react";
import ContentLayout from "../layouts/ContentLayout";
import AppText from "../other/AppText";

interface ILocationsIndexHeader {
  label: string;
  heading: string;
  subheading: string;
}

const LocationsIndexHeader = ({ label, heading, subheading }: ILocationsIndexHeader) => {
  return (
    <ContentLayout bgColorClass="bg-navy-blue">
      {label && (
        <AppText type="LABEL_LARGE" className="text-mellow mb-2 text-center">
          {label}
        </AppText>
      )}

      <AppText type="HEADLINE_LARGE" className="mb-4 text-center text-white">
        {heading}
      </AppText>

      <AppText type="SUB_HEADING_MEDIUM" className="text-center text-white">
        {subheading}
      </AppText>
    </ContentLayout>
  );
};

export default LocationsIndexHeader;
